import React from 'react';
import ExperienceCallout from '@nmx/template/dist/componentLibrary/modules/ExperienceCallout';
import PaperMoneyParachuteIcon from '@nmx/template/dist/componentLibrary/foundations/Illustration/illustrations/darkTheme/PaperMoneyParachute';

export default () => (
  <ExperienceCallout
    isFullWidth
    withBGImage={false}
    sectionId='physician-disability-insurance-calc-experience-callout'
    illustration={PaperMoneyParachuteIcon}
    headingText='Disability Insurance Calculator'
    descriptionText={<>How much disability insurance do you need to protect your income&#63;</>}
    linkUrl='/disability-insurance/disability-insurance-calculator/'
    buttonText='Calculate it'
    moduleName='tool-experience-module'
    backgroundVariant='darkDefault'
    calloutBackgroundVariant='darkDefault'
    calloutThemeType='darkTheme'
    themeType='darkTheme'
    disableLazyLoad
  />
);
